import * as BetTypeMap from '../../constants/BetType';
import Single from './betTypesComponents/Single';
import MultiBet from './betTypesComponents/MultiBet';
import System from './betTypesComponents/System';
export default function (betType) {
    switch (betType) {
        case BetTypeMap.EXPRESS:
        case BetTypeMap.ANTIEXPRESS:
            return MultiBet;
        case BetTypeMap.SYSTEM:
            return System;
        default:
            return Single;
    }
}



// WEBPACK FOOTER //
// ./src/components/coupon/betTypeFactory.js